import { ApiVersions } from '../api-versions';
import { type PostAuditLogEntriesOpenAPIQueryParams } from '../generated/operations/raw-openapi-query-params-for-serializers';

export const apiVersion = ApiVersions.Beta;

export interface PostAuditLogEntriesQueryParams extends Omit<PostAuditLogEntriesOpenAPIQueryParams, 'member'> {
  member?: string | string[];
}

export function querySerializer(queryParams: PostAuditLogEntriesQueryParams) {
  const searchParams = new URLSearchParams();

  if (queryParams.q && queryParams.q.length > 0) {
    searchParams.set('q', queryParams.q);
  }

  const members = typeof queryParams.member === 'string' ? [queryParams.member] : (queryParams.member ?? []);
  for (const member of members) {
    if (member.length > 0) {
      searchParams.append('member', member);
    }
  }

  if ((queryParams.limit ?? 0) > 0) {
    searchParams.set('limit', String(queryParams.limit));
  }

  if (queryParams.after) {
    searchParams.set('after', String(queryParams.after));
  }

  if (queryParams.before) {
    searchParams.set('before', String(queryParams.before));
  }

  return searchParams.toString();
}
